export const StatDetails = {
  General: {
    instagram_followers: {
      type: 'range',
      min: 0,
      max: 10000000,
      title: 'Social',
      displayType: 'abbr'
    }
  },
  Female: {
    height: {
      type: 'range',
      min: 66,
      max: 80,
      increment: 0.5,
      title: 'Height',
      displayType: 'ftIn'
    },
    bust: {
      type: 'range',
      min: 27,
      max: 47,
      increment: 0.5,
      title: 'Bust',
      displayType: 'inCm'
    },
    waist: {
      type: 'range',
      min: 19,
      max: 45,
      increment: 0.5,
      title: 'Waist',
      displayType: 'inCm'
    },
    hip: {
      type: 'range',
      min: 31,
      max: 50,
      increment: 0.5,
      title: 'Hips',
      displayType: 'inCm'
    },
    shoe: {
      type: 'range',
      min: 5.5,
      max: 13,
      increment: 0.5,
      title: 'Shoe Size',
      displayType: 'USEU'
    },
    dress: {
      type: 'range',
      min: 0,
      max: 20,
      increment: 0.5,
      title: 'Dress',
      displayType: 'USEU'
    },
    ethnicity: {
      type: 'list',
      values: ['White', 'Black', 'Asian', 'Hispanic', 'Mixed', 'Other'],
      title: 'Ethnicity',
      displayType: 'asIs'
    },
    hair_color: {
      type: 'list',
      values: ['Black', 'Blond', 'Brown', 'Chestnut', 'Grey', 'Red'],
      title: 'Hair Color',
      displayType: 'asIs'
    },
    eye_color: {
      type: 'list',
      values: ['Amber', 'Blue', 'Brown', 'Grey', 'Green', 'Hazel'],
      title: 'Eye Color',
      displayType: 'asIs'
    },
    cup_size: {
      type: 'list',
      values: ['AA', 'A', 'B', 'C', 'D', 'E(DD)'],
      title: 'Cup Size',
      displayType: 'asIs'
    },
    tags: {
      type: 'list_ids',
      title: 'Tags',
      displayType: 'asIs',
      values: [
        { id: 'plus_size', title: 'Plus Size'} ,
        { id: 'mature', title: 'Mature' },
        { id: 'edgy', title: 'Edgy' },
        { id: 'tattoos', title: 'Tattoos'},
        { id: 'piercings', title: 'Piercings'}
      ],
    }
  },
  Male: {
    height: {
      type: 'range',
      min: 66,
      max: 80,
      increment: 0.5,
      title: 'Height',
      displayType: 'ftIn'
    },
    waist: {
      type: 'range',
      min: 22,
      max: 45,
      increment: 0.5,
      title: 'Waist',
      displayType: 'inCm'
    },
    chest: {
      type: 'range',
      min: 31,
      max: 55,
      increment: 0.5,
      title: 'Chest',
      displayType: 'inCm'
    },
    shoe: {
      type: 'range',
      min: 7,
      max: 17,
      increment: 0.5,
      title: 'Shoe Size',
      displayType: 'USEU'
    },
    ethnicity: {
      type: 'list',
      values: ['White', 'Black', 'Asian', 'Hispanic', 'Mixed', 'Other'],
      title: 'Ethnicity',
      displayType: 'asIs'
    },
    eye_color: {
      type: 'list',
      values: ['Amber', 'Blue', 'Brown', 'Grey', 'Green', 'Hazel'],
      title: 'Eye Color',
      displayType: 'asIs'
    },
    hair_color: {
      type: 'list',
      values: ['Black', 'Blond', 'Brown', 'Chestnut', 'Grey', 'Red'],
      title: 'Hair Color',
      displayType: 'asIs'
    }
  }
  
};


export const StatHelpers = {
  renderStat(input, displayType) {
    let output = '';
    if (displayType === 'ftIn') {
      const outputFeet = (input - (input % 12)) / 12;
      const outputInches = input % 12;
      output = `${outputFeet}' ${outputInches}"`;
    } else if (displayType === 'USEU') {
      const usValue = input % 1 === 0 ? parseInt(input,10).toString() : input;
      output = `${usValue}    ${parseFloat(input, 10) + 30.5}EU`;
    } else if (displayType === 'inCm') {
      output = input % 1 === 0 ? `${parseInt(input, 10).toString()}"` : `${input}"`;
    } else if (displayType === 'asIs') {
      output = input;
    } else if (displayType === 'abbr') {
      output = StatHelpers.abbrNumber(input, 0);
    }
    return output;
  },
  getStatRange() {},
  inchesToFeet(inches) {
    let newInches = parseInt(inches, 10);
    const feet = Math.floor(newInches / 12);
    newInches %= 12;
    return `${feet}' ${inches}"`;
  },
  abbrNumber(number, decPlacesParam) {
    const decPlaces = 10 ** decPlacesParam;
    const abbrev = ['K', 'M', 'B', 'T'];
    let i = abbrev.length - 1;
    while (i >= 0) {
      const size = 10 ** ((i + 1) * 3);
      if (size <= number) {
        number = Math.round(number * decPlaces / size) / decPlaces;
        if (number === 1000 && i < abbrev.length - 1) {
          number = 1;
          i += 1;
        }
        number += abbrev[i];
        break;
      }
      i -= 1;
    }
    return number;
  },
  formatMeasurement(measurement) {
    if (parseFloat(measurement) % 1 === 0) {
      return `${parseInt(measurement, 10)}"`;
    }
    return `${parseFloat(measurement).toFixed(1)}"`;
  },
};

